import { createApp } from 'vue';
import store from "./store/index.js";
import router from "./router";
import App from './App.vue';

// Import CSS files
import "@/assets/css/nucleo-icons.css";
import "@/assets/css/nucleo-svg.css";
import "@/assets/css/modlacss.css";
import 'perfect-scrollbar/css/perfect-scrollbar.css';
import "@/assets/css/material-dashboard.css";
import "@/assets/css/dataTables.responsive.css";
import "@/assets/css/mainimagecapture.css";
import "@/assets/css/jquery.treetable.theme.default.css";
import "@/assets/source/css/prism.css";
import "@/assets/css/MultiStep.css"
import '@/assets/css/choices.css'


import "@/assets/js/plugins/smooth-scrollbar.min.js";
import "@/assets/js/plugins/perfect-scrollbar.min.js";
import "@/assets/js/plugins/round-slider.min.js";
import "@/assets/source/js/prism.js";

// Dark mode functionality
import { activateDarkMode } from "@/assets/js/dark-mode";

import jQuery from "jquery";
import "datatables.net-bs5"


// Make jQuery globally available
window.$ = window.jQuery = jQuery;
const appInstance = createApp(App);
appInstance.use(store);
appInstance.use(router);


// Handle dark mode
if (localStorage.getItem("theme") === "1") {
    activateDarkMode();
    store.state.isDarkMode = true;
} else {
    store.state.isDarkMode = false;
}

appInstance.mount("#app");
